import { useEffect, useState } from "react";
import { FileDownload } from "../core/types";
import { HookResult } from "./types";
import { useFileManager } from "./use-file-manager";
import { useIntersectionObserver } from "./use-intersection-observer";

interface Props {
	uri: string;
	once?: boolean;
}

type AttachmentReturn = {
	ref: (node?: Element | null) => void;
};

export function useAttachment({
	uri,
}: Props): HookResult<FileDownload> & AttachmentReturn {
	const manager = useFileManager();
	const { ref } = useIntersectionObserver({
		freezeOnceVisible: true,
		onChange: (isIntersecting) => {
			if (isIntersecting) {
				manager.download(uri, {
					onSuccess: (event) => {
						setResult({
							data: event.value,
							error: null,
							isLoading: false,
						});
					},
				});
			}
		},
	});

	const [result, setResult] = useState<HookResult<FileDownload>>({
		data: undefined,
		error: null,
		isLoading: true,
	});

	useEffect(() => {
		manager.preload(uri, (data) => {
			setResult({
				data,
				error: null,
				isLoading: false,
			});
		});
	}, [uri]);

	return { ...result, ref };
}
